import onlyNumbers from './onlyNumbers';

export default async function getCepData(cep: string) {
  let cepInfo;
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    cepInfo = await response.json();
    if (cepInfo.erro) {
      const secondAttempt = await fetch(`https://opencep.com/v1/${onlyNumbers(cep)}.json`);
      cepInfo = await secondAttempt.json();

      if (cepInfo.error) {
        return { error: true };
      }
    }

    return cepInfo;
  } catch (error) {
    const secondAttempt = await fetch(`https://opencep.com/v1/${onlyNumbers(cep)}.json`);
    cepInfo = await secondAttempt.json();

    if (cepInfo.error) {
      return { error: true };
    }

    return cepInfo;
  }
}
